{
  "id": "campaign-033",
  "name": "Crooked Green",
  "seed": "campaign:33",
  "startDir": "E",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "............",
    "............",
    "..l......l..",
    "...........x",
    "............",
    "............",
    ".....~......",
    ".....~......",
    "____________",
    ".,.sss......",
    ",,..ww......",
    "..n.ww...n..",
    ".*.*.**.*.*.",
    "..#.........",
    "....n..n....",
    ".....#......",
    "............",
    "S..........."
  ],
  "critters": [
    {
      "kind": "rabbit",
      "x": 7,
      "y": 7
    },
    {
      "kind": "squirrel",
      "x": 5,
      "y": 5
    },
    {
      "kind": "squirrel",
      "x": 2,
      "y": 4
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 3,
      "y": 2
    },
    {
      "kind": "gas",
      "x": 5,
      "y": 0
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 2,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 0,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 11,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 3,
      "y": 16
    },
    {
      "kind": "coin",
      "x": 0,
      "y": 4
    },
    {
      "kind": "coin",
      "x": 8,
      "y": 7
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 11
    }
  ],
  "generatorVersion": 3,
  "level": 33,
  "biome": "park",
  "par": {
    "reel": 7158,
    "push": 5949,
    "selfPropelled": 5538,
    "tractor": 5115,
    "zeroTurn": 4121,
    "fairway": 2212
  },
  "routeTries": {
    "par": {
      "reel": 0,
      "push": 0,
      "selfPropelled": 0,
      "tractor": 24,
      "zeroTurn": 8,
      "fairway": 22
    }
  }
}
